<script setup lang="ts">
import QueueKioskPage from "@/modules/queue/pages/QueueKioskPage.vue";

definePage({
  meta: {
    layout: "blank",
    public: true,
  },
});
</script>

<template>
  <QueueKioskPage />
</template>
